import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const ActionModal = styled(Modal)`
  .custom-modal {
    max-width: 68%;
    margin: auto;
    margin-top: 20px;
    @media (max-width: 1280px) {
      max-width: 90%;
    }
  }
  .modal-header {
    height: 100px;
    padding: 0px 80px;
    background: #fff;
    color: #58079e;
    border-bottom: transparent;

    .modal-title {
      margin-top: auto;
      width: 100%;
      border-bottom: 1px solid #dee2e6;
      @media (max-width: 1280px) {
        margin-top: 0;
      }
    }

    @media (max-width: 1280px) {
      height: 60px;
      padding: 0px 40px;
    }
  }
  .modal-body {
    margin-top: 0.625rem;
    padding-left: 80px;
    padding-right: 80px;

    @media (max-width: 1280px) {
      padding: 0px 40px 0px 40px;
    }

    .modal-acoes {
      height: 70px;
      transition: 0.3s;
      cursor: pointer;

      & + .modal-acoes {
        border-top: 1px solid #ededed;
      }
      & + a {
        border-top: 1px solid #ededed !important;
      }
      h5 {
        font-size: 18px;
        color: #474747;
      }
      small {
        font-size: 13px;
      }
      svg {
        color: ${(props) => props.theme.colors.nav} !important;
      }
    }
    .executando {
      background: #ebebeb;
      transition: 0.3s;

      cursor: default;
      h5 {
        color: #a19d9d !important;
      }
      small {
        color: #a19d9d !important;
      }
      svg {
        color: #9d7dbd !important;
      }
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
    }
    .nav-tabs {
      border: none;
      .nav-item {
        display: none;
        visibility: hidden;
      }
    }
    .button-confirm {
      margin-top: 31px;
    }
  }
  .modal-footer {
    button {
      background: ${(props) => props.theme.colors.nav};
      border-color: ${(props) => props.theme.colors.nav};

      &:focus:not(.focus-visible) {
        outline: none !important;
        outline: 0px !important;
        -webkit-appearance: none;
        appearance: none;
        box-shadow: none !important;
      }
      &:focus-visible {
        outline: 2px solid ${(props) => props.theme.colors.nav} !important;
      }
    }
  }
`;
